export const tableHeader = [
  'Select',
  'Course',
  'Subject',
  'Chapter',
  'Topic',
  'Class',
  'Difficulty Level',
  'Question Type',
  'Status',
  'Action'
]
